import { put } from 'redux-saga/effects'
import { IPcr } from '../../../../pcr/store/pcr.types'
import { getSelectedDataFromObject } from '../../../../../utilities/data.util'
import { glassgowCommaScorePrNabc } from '../store/glassgowCommaScore.reducers'
import { setGlassgowCommaScoreData } from '../store/glassgowCommaScore.actions'

export function* getGlassgowCommaScore(pcrDoc: IPcr) {
  let glassgowCommaScorePrNabcData = {}

  if (pcrDoc.prNabc) {
    const glassgowCommaScorePrNeuroKeys: any = Object.keys(glassgowCommaScorePrNabc)
    glassgowCommaScorePrNabcData = getSelectedDataFromObject(pcrDoc.prNabc, glassgowCommaScorePrNeuroKeys)
  }

  if (
    Object.keys(glassgowCommaScorePrNabcData).length !== 0 ||
    pcrDoc.prGcsQualifier?.length !== 0 ||
    pcrDoc.prGcsQualifierPNNV ||
    Object.keys(pcrDoc._uiPlaceHolder?.gcsPlaceholders).length !== 0
  ) {
    yield put(
      setGlassgowCommaScoreData({
        ...glassgowCommaScorePrNabcData,
        ...pcrDoc._uiPlaceHolder?.gcsPlaceholders,
        qualifier: pcrDoc.prGcsQualifier || [],
        qualifierPNNV: pcrDoc.prGcsQualifierPNNV || null,
      })
    )
  }
}
